var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgICheckedGreen = function SvgICheckedGreen(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.48771 16.5737L4.69471 12.7807C4.50611 12.5986 4.25351 12.4978 3.99131 12.5C3.72911 12.5023 3.4783 12.6075 3.29289 12.7929C3.10749 12.9783 3.00232 13.2291 3.00004 13.4913C2.99776 13.7535 3.09855 14.0061 3.28071 14.1947L7.78071 18.6947C7.96824 18.8822 8.22255 18.9875 8.48771 18.9875C8.75288 18.9875 9.00718 18.8822 9.19471 18.6947L20.1947 7.69471C20.3769 7.50611 20.4777 7.25351 20.4754 6.99131C20.4731 6.72911 20.3679 6.4783 20.1825 6.29289C19.9971 6.10749 19.7463 6.00232 19.4841 6.00004C19.2219 5.99776 18.9693 6.09855 18.7807 6.28071L8.48771 16.5737Z",
    fill: "#3AD98A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    stroke: "#3AD98A"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgICheckedGreen);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/i-checked-green.c57a01cc586380acb71b2c8de45e91cc.svg";